import {
  hasValue,
  safeParseZod,
  pp_mapByNestedKeys,
  ensureValidUri,
  getPPUrl,
} from '@r-and-a-shared-ui/utils';
import z from 'zod';
import { ActionHandlerParams } from '../../types';
import { validateForm } from '../../helpers/config-helper';

export const pp_preExecMutationCheckWithFormValidation = async <
  Type extends z.ZodSchema,
>(
  params: ActionHandlerParams,
  schema: Type,
  defaultValuesObj?: unknown,
): Promise<z.TypeOf<Type> | undefined> => {
  const isValid = await validateForm(params);
  if (!isValid) {
    return undefined;
  }

  return pp_preExecMutationCheck(params, schema, defaultValuesObj);
};

export const pp_preExecMutationCheck = async <Type extends z.ZodSchema>(
  params: ActionHandlerParams,
  schema: Type,
  defaultValuesObj?: unknown,
): Promise<z.TypeOf<Type> | undefined> => {
  const { resource, submitData, bearerToken, cognitoToken } = params;

  let mappedObject: any = pp_mapByNestedKeys(
    submitData,
    structuredClone(defaultValuesObj),
    '_',
  );

  if (!hasValue(resource)) {
    return safeParseZod(schema, mappedObject);
  }
  const objectToSubmit: any = {
    callBackUrl: ensureValidUri(resource, getPPUrl()),
    data: mappedObject,
  };

  if (bearerToken) {
    objectToSubmit.bearerToken = bearerToken;
  }
  if (cognitoToken) {
    objectToSubmit.cognitoToken = cognitoToken;
  }
  return safeParseZod(schema, objectToSubmit);
};
